import { useSelector } from "react-redux";

export const useAccessRights = () => {
  const accessRights = useSelector((state) => state.auth.accessRights);

  const isServiceEnabled = (serviceName) => {
    if (!accessRights) return false;
    return accessRights[serviceName]?.enabled === true;
  };

  // const getEnabledLayerServices = () => {
  //   const layers = accessRights?.display_layers_service?.allowed_layers;
  //   if (!layers) return [];
  //   return Object.entries(layers)
  //     .filter(([, enabled]) => enabled === true)
  //     .map(([key]) => key);
  // };

  // Generic: allowed_countries can appear under any service
  // (display_layers_service, historic_fire_service, ...) — caller must
  // say which one explicitly, no implicit default.
  const getAllowedCountries = (serviceName) => {
    if (!accessRights || !serviceName) return [];
    const countries = accessRights[serviceName]?.allowed_countries;
    if (!countries) return [];
    return Object.entries(countries)
      .filter(([, enabled]) => enabled === true)
      .map(([key]) => key);
  };

  // Generic: allowed_departments can appear under any service —
  // same reasoning as getAllowedCountries.
  const getAllowedDepartments = (serviceName) => {
    if (!accessRights || !serviceName) return [];
    const departments = accessRights[serviceName]?.allowed_departments;
    if (!departments) return [];
    return Object.entries(departments)
      .filter(([, enabled]) => enabled === true)
      .map(([key]) => key);
  };
  // Generic: timeline interval (in days, relative to today) can appear
  // under any service — same reasoning as getAllowedCountries.
  const getTimelineLimits = (serviceName) => {
    if (!accessRights || !serviceName) return null;
    const timeline = accessRights[serviceName]?.timeline;
    if (!timeline) return null;
    return {
      intervalMinJ: timeline.interval_min_j ?? null,
      intervalMaxJ: timeline.interval_max_j ?? null,
    };
  };
  // Generic check for a specific allowed_layers flag under any service
  // e.g. canAccessLayer('auth', 'login_dashboard')
  const canAccessLayer = (serviceName, layerName) => {
    if (!accessRights) return false;
    return accessRights[serviceName]?.allowed_layers?.[layerName] === true;
  };
 const getDateRangeLimits = (serviceName) => {
  if (!accessRights || !serviceName) return null;
  const timeline = accessRights[serviceName]?.timeline;
  if (!timeline) return null;
  // Each bound is independent: a missing/null date_start means "no lower
  // bound" (full access from the start), a missing/null date_end means
  // "no upper bound" (defaults to today higher up the stack).
  return {
    dateStart: timeline.date_start ?? null,
    dateEnd: timeline.date_end ?? null,
  };
};
  return {
    accessRights,
    isServiceEnabled,
    // getEnabledLayerServices,
    getAllowedCountries,
    getAllowedDepartments,
    getTimelineLimits,
    getDateRangeLimits,
    canAccessLayer,
  };
};
